/* eslint-disable boundaries/element-types */
import { createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { LoggedInContent } from 'app/LoggedInContent'
import { GeckoAuthProvider } from 'features/auth'
import { TermsModalProvider } from 'features/terms'
import * as React from 'react'
import type { Cache } from 'swr'

export const Route = createRootRouteWithContext<{ cache: Cache }>()({
  component: RootComponent,
  errorComponent: () => <div>There was an error</div>,
})

function RootComponent() {
  return (
    <React.Fragment>
      <TermsModalProvider>
        <GeckoAuthProvider>
          <LoggedInContent />
        </GeckoAuthProvider>
      </TermsModalProvider>
      <TanStackRouterDevtools position='bottom-left' containerElement={'div'} />
    </React.Fragment>
  )
}
